module.exports = __webpack_public_path__ + "img/04lvju.653f2890.png";